export default __webpack_public_path__ + "static/media/wellbeing-chart.78d2b83e.svg";